/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { AttachmentSnapshotFragmentDoc, AttachmentsFragmentDoc, WithItemAttachmentsFragmentDoc } from '../../features/attachments/Attachments.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SupplierProfileQueryVariables = Types.Exact<{
  supplierId: Types.Scalars['ID']['input'];
}>;


export type SupplierProfileQuery = { pimSupplier: { __typename: 'PimSupplierResult', supplier: { __typename: 'PimSupplier', id: string, title: string, logo?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null, linkedCrmCompany?: { __typename: 'CrmCompany', id: string, title: string } | null } } };


export const SupplierProfileDocument = gql`
    query SupplierProfile($supplierId: ID!) {
  pimSupplier(id: $supplierId) {
    supplier {
      id
      title
      logo {
        ...AttachmentSnapshot
      }
      linkedCrmCompany {
        id
        title
      }
    }
  }
}
    ${AttachmentSnapshotFragmentDoc}`;

/**
 * __useSupplierProfileQuery__
 *
 * To run a query within a React component, call `useSupplierProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupplierProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplierProfileQuery({
 *   variables: {
 *      supplierId: // value for 'supplierId'
 *   },
 * });
 */
export function useSupplierProfileQuery(baseOptions: Apollo.QueryHookOptions<SupplierProfileQuery, SupplierProfileQueryVariables> & ({ variables: SupplierProfileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SupplierProfileQuery, SupplierProfileQueryVariables>(SupplierProfileDocument, options);
      }
export function useSupplierProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SupplierProfileQuery, SupplierProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SupplierProfileQuery, SupplierProfileQueryVariables>(SupplierProfileDocument, options);
        }
export function useSupplierProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SupplierProfileQuery, SupplierProfileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SupplierProfileQuery, SupplierProfileQueryVariables>(SupplierProfileDocument, options);
        }
export type SupplierProfileQueryHookResult = ReturnType<typeof useSupplierProfileQuery>;
export type SupplierProfileLazyQueryHookResult = ReturnType<typeof useSupplierProfileLazyQuery>;
export type SupplierProfileSuspenseQueryHookResult = ReturnType<typeof useSupplierProfileSuspenseQuery>;
export type SupplierProfileQueryResult = Apollo.QueryResult<SupplierProfileQuery, SupplierProfileQueryVariables>;